import { DEFAULT_STATE } from '../constants'

export const initialMoreFiltersState = {
  advancedFilters: DEFAULT_STATE.advancedFilters,
  personalFilter: DEFAULT_STATE.personalFilter,
  purchaseFilter: DEFAULT_STATE.purchaseFilter,
}
